<div [formGroup]="form" [hidden]="isHidden" #field class="se-measure--container measure-container">
    <mat-form-field
        appearance="outline"
        floatLabel="always"
        class="se-flex-1-1-auto se-form-field custom-measure"
        [class.se-measure--out-of-range-accent]="!!warningMessage"
        [class.label-filled]="formControl && formControl.value && formControl.value.toString().trim().length > 0"
    >
        @if (control.isWithLabel) {
            <mat-label title="{{ control.name }}{{ additionalLabelInfo }}">
                {{ control.name }}{{ additionalLabelInfo }}
            </mat-label>
        }
        <div [title]="onFocusInputMeasure(inputElement.value)" #tooltipElement>
            <input
                #inputElement
                class="se-form-field-input"
                [ngClass]="{ 'input-no-label': !control.isWithLabel, 'input-label': control.isWithLabel }"
                matInput
                autocomplete="off"
                [errorStateMatcher]="errorStateMatcher"
                [formControl]="formControl"
                [pattern]="pattern"
                (change)="onMeasureChange()"
                (focusin)="onFocusIn()"
                (blur)="onBlur()"
            />
            <span class="invisible" #invisibleElement [innerHtml]="inputElement.value"></span>
        </div>
        <div matSuffix style="display: flex">
            <div
                #unitOfMeasure
                class="unit-of-measure mat-mdc-form-field-icon-suffix"
                [ngClass]="{ hideMeasure: hideUnitOfMeasure() }"
            >
                {{ unitOfMeasureDisplayed }}
            </div>

            <span #measureIcon>
                @if (config && config.detailsEnabled) {
                    <mat-icon
                        style="vertical-align: middle; margin-left: 5px; z-index: 99; cursor: pointer"
                        [class.cp-measure-pointer]="control.config.idPanel"
                        (click)="onPanelButtonClick($event)"
                    >
                        {{ icon }}
                        @let badge = badgeSource$ | async;
                        @if (badge) {
                            <span
                                class="mat-badge-content"
                                style="margin-left: -5px"
                                matBadge="{{ badge }}"
                                [matBadgeHidden]="+badge <= 1"
                                matBadgePosition="before"
                                matBadgeSize="medium"
                            ></span>
                        }
                    </mat-icon>
                }
            </span>
        </div>
    </mat-form-field>
    @if (hasAIData) {
        <div class="measure-ai-label-container">
            <div class="measure-ai-label-content">AI</div>
        </div>
    }
</div>
